import { SvgIcon } from "@mui/material";

const PauseIcon = () => {
  return (
    <SvgIcon viewBox="0 0 10 12" fill="none" width="10" height="12">
      <path
        d="M1.66667 11.8334C2.58333 11.8334 3.33333 11.0834 3.33333 10.1667V1.83341C3.33333 0.916748 2.58333 0.166748 1.66667 0.166748C0.75 0.166748 0 0.916748 0 1.83341V10.1667C0 11.0834 0.75 11.8334 1.66667 11.8334ZM6.66667 1.83341V10.1667C6.66667 11.0834 7.41667 11.8334 8.33333 11.8334C9.25 11.8334 10 11.0834 10 10.1667V1.83341C10 0.916748 9.25 0.166748 8.33333 0.166748C7.41667 0.166748 6.66667 0.916748 6.66667 1.83341Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export default PauseIcon;
